import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store'
const _import = require('./_import_' + process.env.NODE_ENV)//获取组件的方法
import tpView from '@/views/layout/tpView'
Vue.use(Router)

var getRouter 
//用来获取后台拿到的路由
function routerGo() {
  getRouter = filterAsyncRouter(getRouter) 
  //过滤路由
}

function saveObjArr(name, data) { 
  //localStorage 存储数组对象的方法
  localStorage.setItem(name, JSON.stringify(data))
}

function getObjArr(name) { 
  //localStorage 获取数组对象的方法
  return JSON.parse(localStorage.getItem(name));

}

function filterChildren(item) { 
  //遍历后台传来的路由字符串，children第一个
  var redirects=item['path']
  if (item.children && item.children.length) {
    redirects+='/'+filterChildren(item.children[0])
  }
  return redirects
}

function filterAsyncRouter(asyncRouterMap) { //遍历后台传来的路由字符串，转换为组件对象
  const accessedRouters = asyncRouterMap.filter(route => {
    if (route.component){
      if(route.component==="textListView" && (route.children && !route.children.length)){
        route.component=tpView
        route.children=[{
          component:'textListView',
          meta:{
            breadcrumb:false,//route.meta.breadcrumb+"列表",
            isLogin:route.meta.isLogin,
            keywords:route.meta.keywords||"",
            description:route.meta.description||"",
            id:route.meta.id
          },
          name:"list"+route.meta.id,
          path:"list"
        },{
          component:'contextDetails',
          meta:{
            breadcrumb:"详情",
            isLogin:route.meta.isLogin,
            keywords:route.meta.keywords||"",
            description:route.meta.description||"",
            id:route.meta.id
          },
          name:"details"+route.meta.id,
          path:"details/:id"
        }]
      }else if(route.component==="picListView" && (route.children && !route.children.length)){
        route.component=tpView
        route.children=[{
          component:'picListView',
          meta:{
            breadcrumb:false,//route.meta.breadcrumb+"列表",
            isLogin:route.meta.isLogin,
            keywords:route.meta.keywords||"",
            description:route.meta.description||"",
            id:route.meta.id
          },
          name:"list"+route.meta.id,
          path:"list"
        },{
          component:'picDetailsView',
          meta:{
            breadcrumb:"详情",
            isLogin:route.meta.isLogin,
            keywords:route.meta.keywords||"",
            description:route.meta.description||"",
            id:route.meta.id
          },
          name:"details"+route.meta.id,
          path:"details/:id"
        }]
      }else if(route.component==="picView" && (route.children && !route.children.length)){
        route.component=tpView
        route.children=[{
          component:'picView',
          meta:{
            breadcrumb:false,//route.meta.breadcrumb+"列表",
            isLogin:route.meta.isLogin,
            keywords:route.meta.keywords||"四川长江经济研究院|"+route.meta.breadcrumb,
            description:route.meta.description||"",
            id:route.meta.id
          },
          name:"list"+route.meta.id,
          path:"list"
        },{
          component:'picDetailsView',
          meta:{
            breadcrumb:"详情",
            isLogin:route.meta.isLogin,
            keywords:route.meta.keywords||"",
            description:route.meta.description||"",
            id:route.meta.id
          },
          name:"details"+route.meta.id,
          path:"details/:id"
        }]
      }else{
        route.component = _import(route.component)
      }
    }
    if (route.children && route.children.length) {
      route.children = filterAsyncRouter(route.children)
      var redirects=filterChildren(route)
      if(redirects){
        route.redirect=redirects
      }
    }
    return true
  })

  return accessedRouters
}
if (!getRouter) {
  if (!getObjArr('router')) {
    store.dispatch("Router").then(res=>{
      getRouter = res.data//后台拿到路由
      //执行路由跳转方法
      routerGo()
      window.location.reload();
    });
  } else {//从localStorage拿到了路由
    getRouter = getObjArr('router')//拿到路由
    routerGo()
  }
}



// 配置路由对象数组
export let constantRouterMap = [
  {
    path: '/',
    redirect:'/index',
    component:()=>import('@/views/layout/routeView'),
    meta: {
      breadcrumb:false,
      isLogin: false
    },
    children:[{
      path: '/index',
      name: 'home',
      component:()=>import('@/views/home'),
      meta: {
        breadcrumb:"首页",
        keywords:"四川长江经济研究院",
        description:"四川长江经济研究院",
        isLogin: false
      }
    },{
      path: '/login',
      name: 'login',
      component:()=>import('@/views/user/login'),
      hidden: true,
      meta: {
        breadcrumb: '用户登录',
        isLogin: false
      }
    },{
      path: '/register',
      name: 'register',
      component:()=>import('@/views/user/register'),
      hidden: true,
      meta: {
        breadcrumb: '用户注册',
        isLogin: false
      }
    },{
      path: '/search',
      name: 'search',
      redirect:'/search/list',
      component:tpView,
      hidden: true,
      meta: {
        isLogin: false
      },
      children:[{
        path: 'list',
        name: 'searchList',
        component:()=>import('@/views/search'),
        hidden: true,
        meta: {
          isLogin: false
        }
      },{
        path: 'details/:id',
        name: 'searchDetails',
        component:()=>import('@/views/contextDetails/searchDetails'),
        hidden: true,
        meta: {
          isLogin: false
        }
      }]
    },
    ...getRouter]
  },
  { path: '*', component: () => import('@/views/error'), hidden: true }];


// 实例化路由
export default new Router({
  mode: 'history', //后端支持可开
  base:'/',
  scrollBehavior: () => ({ y: 0 }),
  routes:constantRouterMap
});



// WEBPACK FOOTER //
// ./src/router/index.js